import { Button, Chip, TextField } from '@mui/material'
import React, { useState } from 'react'
import DialogWrapper from '../../../components/core-ui/DialogWrapper'
import { categoryService } from '../../../services/categoryService'
import { useAuthContext } from '../../../hooks/useAuthContext'
import { toast } from 'react-toastify'

const KeywordList = ({ categories, selectedCategory, onSelect, refreshCategories = () => {} }) => {
  const { user } = useAuthContext()
  const [category, setCategory] = useState('')
  const [description, setDescription] = useState('')
  const [openCreateDialog, setOpenCreateDialog] = useState(false)

  const handleClick = (category) => {
    if (category.id === 100000) {
      setOpenCreateDialog(true)
    } else {
      onSelect(category)
    }
  }

  const createCategory = async () => {
    const sequence = categories.length + 2
    try {
      const insertedCategory = await categoryService.createCategory(user, {
        name: category,
        description,
        sequence,
      })
      toast.success(`Added new category "${insertedCategory.name}"`)
      setOpenCreateDialog(false)
      setCategory('')
      setDescription('')
      refreshCategories()
    } catch (error) {
      toast.error(`Something went wrong!`)
    }
  }

  return (
    <div style={{ display: 'flex', columnGap: 8, rowGap: 8, margin: '16px 8px', flexWrap: 'wrap' }}>
      {[...categories, { id: 100000, name: 'Add New +' }].map((category) => (
        <Chip
          label={category.name}
          key={category.id}
          onClick={() => handleClick(category)}
          style={{ background: selectedCategory.id == category.id ? '#aeadfa' : '' }}
        ></Chip>
      ))}
      {openCreateDialog && (
        <DialogWrapper
          heading={'Create Category'}
          open={openCreateDialog}
          onClose={() => setOpenCreateDialog(false)}
          actions={
            <>
              <Button
                variant="contained"
                onClick={() => {
                  setOpenCreateDialog(false)
                  setCategory('')
                  setDescription('')
                }}
              >
                Cancel
              </Button>
              <Button color="primary" variant="contained" onClick={createCategory}>
                Save
              </Button>
            </>
          }
        >
          <TextField
            size="small"
            style={{ margin: '8px 0px' }}
            id="outlined"
            label="Name"
            placeholder="Name"
            sx={{ width: '100%' }}
            onChange={(e) => setCategory(e.target.value)}
            value={category}
          />
          <TextField
            size="small"
            style={{ margin: '8px 0px' }}
            id="outlined"
            label="Description"
            placeholder="Description"
            sx={{ width: '100%' }}
            onChange={(e) => setDescription(e.target.value)}
            value={description}
          />
        </DialogWrapper>
      )}
    </div>
  )
}

export default KeywordList
